import React from 'react';
import LaboratoryDashboard from './LaboratoryDashboard';
import VolumetrieAnalystDashboard from '../dashboards/VolumetrieAnalystDashboard';
import VolumetrieSupervisorDashboard from '../dashboards/VolumetrieSupervisorDashboard';

interface VolumétrieLaboratoryDashboardProps {
  userRole: 'ANALYSTE' | 'TECHNICIEN' | 'SUPERVISEUR';
  userId: string;
}

const VolumétrieLaboratoryDashboard: React.FC<VolumétrieLaboratoryDashboardProps> = ({
  userRole,
  userId,
}) => {
  // Use comprehensive Volumétrie analyst dashboard for analysts
  if (userRole === 'ANALYSTE') {
    return <VolumetrieAnalystDashboard />;
  }

  // Use comprehensive Volumétrie supervisor dashboard for supervisors
  if (userRole === 'SUPERVISEUR') {
    return <VolumetrieSupervisorDashboard />;
  }

  // Use generic laboratory dashboard for technicians
  return (
    <LaboratoryDashboard
      laboratoryType="VOLUMETRIE"
      laboratoryName="Laboratoire Volumétrie (Titrations)"
      userRole={userRole}
      userId={userId}
    />
  );
};

export default VolumétrieLaboratoryDashboard; 